import React from 'react';
import PropTypes from 'prop-types';
import { get } from '@api/v4/links';

import Hyperlink from './link';
import LinkModal from './link-modal';

import './styles/links.scss';

class LinkList extends React.Component {
  state = {
    editing: false,
    modalOpen: false,
    links: [],
    loaded: false,
  }

  componentDidMount() {
    this.fetchLinks();
  }

  showModal = () => {
    this.setState({ modalOpen: true });
  }

  onNewLinkSave = () => {
    this.fetchLinks();
  }

  updateLink = ({ id, name, url }) => {
    this.setState(({ links }) => ({
      links: links.map((link) => {
        if (link.id !== id) { return link; }

        return {
          ...link,
          name,
          url,
        };
      })
    }));
  }

  onLinkUpdate = (id, link) => {
    if (link.initial) {
      this.onNewLinkSave();
      return;
    }

    if (!link.name && !link.url) {
      // a link was deleted!
      this.setState(({ links }) => ({
        links: links.filter(({ id: i }) => i !== id)
      }));
    } else {
      this.updateLink({ id, ...link });
    }
  }

  initialLinks() {
    if (!this.props.canEdit || !this.state.loaded) { return []; }

    return [
      {
        name: 'LinkedIn',
        url: 'http://linkedin.com',
        id: 'linkedin',
        initial: true,
      },
      {
        name: 'Facebook',
        url: 'http://facebook.com',
        id: 'facebook',
        initial: true,
      },
      {
        name: 'Twitter',
        url: 'http://twitter.com',
        id: 'twitter',
        initial: true,
      },
    ];
  }

  fetchLinks() {
    return get(this.props.brandfolder.key).then((links) => {
      this.setState((state) => ({
        links,
        loaded: true,
        editing: state.editing || links.length === 0,
      }));
    });
  }

  renderButton() {
    const { canEdit } = this.props;
    const { links, editing } = this.state;
    if (!canEdit || !links.length) { return undefined; }

    let inner;
    if (editing) {
      inner = bfTranslate('Done');
    } else {
      inner = (
        <React.Fragment>
          <span aria-hidden="true" className="bff-edit" />
          {bfTranslate('Links')}
        </React.Fragment>
      );
    }

    return (
      <button
        onClick={() => this.setState((state) => ({ editing: !state.editing }))}
        type="button"
        className="button tertiary sm"
      >
        {inner}
      </button>
    );
  }

  render() {
    const { canEdit } = this.props;
    const { editing, modalOpen } = this.state;
    const brandfolderKey = this.props.brandfolder.key;

    const linksToRender = this.state.links.length ? this.state.links : this.initialLinks();
    const links = linksToRender.map((link) => (
      <Hyperlink
        {...link}
        key={link.id}
        editing={editing}
        id={link.id}
        onUpdate={(newLink) => this.onLinkUpdate(link.id, newLink)}
        brandfolderKey={brandfolderKey}
      />
    ));

    return (
      <>
        {links.length > 0 ? (
          <div className="links__container">
            {canEdit && modalOpen ? (
              <LinkModal
                name=""
                url=""
                onUpdate={this.onNewLinkSave}
                onClose={() => this.setState({ modalOpen: false })}
                brandfolderKey={brandfolderKey}
              />
            ) : null}
            {this.renderButton()}
            <ul className="links__list">
              {links}
              {canEdit && editing ? (
                <li>
                  <button
                    type="button"
                    onClick={this.showModal}
                    className="links__add-button"
                  >
                    + {bfTranslate('Add Link')}
                  </button>
                </li>
              ) : null}
            </ul>
          </div>
        ) : ''
        }
      </>
    );
  }
}

LinkList.propTypes = {
  brandfolder: PropTypes.shape({
    key: PropTypes.string
  }).isRequired,
  canEdit: PropTypes.bool,
};

LinkList.defaultProps = {
  canEdit: false,
};

export default LinkList;
